// core
import { Component, Input } from '@angular/core';

// campfire
import { PartnerBrandService, DocumentService } from '@campfire-nx/api';

// services
import { environment } from '@open-portal-env';


@Component({
  selector: 'app-travel-policy',
  templateUrl: './travel-policy.component.html',
  styleUrls: ['./travel-policy.component.scss']
})
export class TravelPolicyComponent {
  @Input() policyDetails!: {[key: string]: any}

  constructor(
    private documentService: DocumentService,
    private partnerBrandService: PartnerBrandService
  ) { }

  downloadDeclaration(event: Event, travellerId: string) {
    event.preventDefault();
    const payload = {
      id: travellerId || ''
    }

    this.documentService.getMedicalDocument(payload, this.policyDetails.slug).then(document => {
      this.documentService.saveFile(document, 'medical_declaration');
    });
  }

  getArrangementFeeMessage() {
    const countryCode = this.partnerBrandService.getCountryCode('country_alpha2');
    const feeMessage = (countryCode === 'GB') ? ' (including 20% Insurance Premium Tax and Policy Arrangement Fee)' : ' (Inc GST)';
    
    return feeMessage;
  }

  get showDeclarationLink() {
    return environment.region === 'uk';
  }
}